const labels = {
  disengage:
    "You are about to <strong>disengage</strong> from this job.</br>You will <strong>not be able to re-engage</strong> to fill <strong>this particular job</strong>.</br></br>Do you want to proceed?",
  reject:
    "Please leave a <strong>reason</strong> why you do not wish to engage with this recruitment professional at this time. The reason provided will be sent to the recruiter in an email.",
  messageallAgencies:
    "You are about to message all <strong>listed</strong> agencies:",
  removeFromPsl:
    "<div>This will not disengage them from any existing jobs, but it will mean they need your approval for new engagement requests.</div></br><div>Do you want to proceed?</div>",
};

export { labels as default };
